import { EFloorType } from 'src/store/view-2d/reducer';

export type IViewType = 'ThreeDSpinner' | 'GroupedPlacementPlanning' | 'FloorPlanning' | 'Map' | 'Crosstable';
export enum ISubViewType {
  DetailedSubView = 'DetailedSubView',
  SimpleSubView = 'SimpleSubView',
  ListSubView = 'ListSubView'
}
export const ISubViewMappingEFloorType = {
  [ISubViewType.DetailedSubView]: EFloorType.moreInfo,
  [ISubViewType.SimpleSubView]: EFloorType.mini,
  [ISubViewType.ListSubView]: EFloorType.list,
};
export type IFrontConfigType = 'website' | 'adminPanel';
export enum ExportButton {
  excel = 'excel',
  pdf = 'pdf',
}

export enum IFrontConfigTypeEnum {
  website = 'website',
  adminPanel = 'adminPanel',
}

export interface IExportPdfData {
  projectLogo: string,
  developerLogo: string,
  issuedDate: string,
  showFlatShowLogo: boolean,
  tableFields: string[],
  tableData: {[key: string]: string}[]
}
